import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Typography, Button, Box, Paper, Container } from '@mui/material';
import { LanguageContext } from '../contexts/LanguageContext';
var LaunchScreen = function (_a) {
    var onProceed = _a.onProceed;
    var _b = useContext(LanguageContext), t = _b.t, setIsFirstRun = _b.setIsFirstRun;
    var handleProceed = function () {
        setIsFirstRun(false);
        onProceed();
    };
    return (_jsx(Container, { maxWidth: "sm", sx: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            py: 2
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                p: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                width: '100%',
                minHeight: { xs: 'calc(100vh - 120px)', sm: 'auto' }
            }, children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, align: "center", children: t('appTitle') }), _jsx(Typography, { variant: "h5", align: "center", gutterBottom: true, sx: { mt: 2 }, children: t('selectLanguage') }), _jsxs(Box, { sx: { width: '100%', mt: 4 }, children: [_jsx(Typography, { variant: "body1", align: "center", paragraph: true, children: t('selectLanguage') }), _jsx(Box, { sx: { display: 'flex', justifyContent: 'center', mt: 2 }, children: _jsx(Button, { variant: "contained", color: "primary", size: "large", onClick: handleProceed, sx: { mt: 3, mb: 2, py: 1.5, px: 4 }, children: t('proceed') }) })] })] }) }));
};
export default LaunchScreen;
